import { GlobalScope_instance1goye8260az8c as GlobalScope_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  writer1eia5its2a1fh as writer,
  writeFully3jo5sennkizsh as writeFully,
  close3semq7pafb42g as close,
  WriterScope3b0bo1enaee6b as WriterScope,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import { get_ByteArrayPool3f7yrgvqxz9ct as get_ByteArrayPool } from '../../../../../ktor-ktor-io/io/ktor/utils/io/pool/ByteArrayPool.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { readAvailable3vfomv92cg41a as readAvailable } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function observable(_this__u8e3s4, context, contentLength, listener) {
  var tmp = GlobalScope_instance;
  return writer(tmp, context, true, observable$slambda_0(_this__u8e3s4, listener, contentLength)).l4k_1;
}
function *_generator_invoke__zhh2q8($this, $this$writer, $completion) {
  var tmp0 = get_ByteArrayPool();
  $l$block: {
    // Inline function 'io.ktor.utils.io.pool.useInstance' call
    var instance = tmp0.e4m();
    try {
      var bytesSend = 0n;
      $l$loop: while (!$this.a5z_1.o4j()) {
        var tmp = readAvailable($this.a5z_1, instance, VOID, VOID, $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
        var read = tmp;
        if (read <= 0)
          continue $l$loop;
        var tmp_0 = writeFully($this$writer.n4k_1, instance, 0, read, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
        // Inline function 'kotlin.Long.plus' call
        var this_0 = bytesSend;
        bytesSend = add(this_0, fromInt(read));
        var tmp_1 = $this.b5z_1.d5l(bytesSend, $this.c5z_1, $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
      }
      var closedCause = $this.a5z_1.m4j();
      close($this$writer.n4k_1, closedCause);
      if (closedCause == null && bytesSend === 0n) {
        var tmp_2 = $this.b5z_1.d5l(bytesSend, $this.c5z_1, $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
      }
      break $l$block;
    }finally {
      tmp0.f4m(instance);
    }
  }
  return Unit_instance;
}
var observable$slambdaClass;
function observable$slambda() {
  if (observable$slambdaClass === VOID) {
    class $ {
      constructor($this_observable, $listener, $contentLength) {
        this.a5z_1 = $this_observable;
        this.b5z_1 = $listener;
        this.c5z_1 = $contentLength;
      }
      z58($this$writer, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$writer), $completion);
      }
      ud(p1, $completion) {
        return this.z58(p1 instanceof WriterScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    observable$slambdaClass = $;
  }
  return observable$slambdaClass;
}
function observable$slambda_0($this_observable, $listener, $contentLength) {
  var i = new (observable$slambda())($this_observable, $listener, $contentLength);
  var l = ($this$writer, $completion) => i.z58($this$writer, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  observable as observable2pw4p3n7s3klf,
};
//endregion

//# sourceMappingURL=ByteChannelUtils.mjs.map
